import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Send, ChevronDown, ChevronUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatSentAt = (iso) =>
  new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });

export const useCpaSends = (advisorId, refreshKey) => {
  const [sends, setSends] = useState([]);
  useEffect(() => {
    if (!advisorId) return;
    axios.get(`${API}/chat/history/email-log`, { params: { advisor_id: advisorId }, withCredentials: true })
      .then(r => setSends(r.data.sends || []))
      .catch(() => setSends([]));
  }, [advisorId, refreshKey]);
  return sends;
};

export const CpaSendItem = ({ send, index }) => (
  <li className="flex items-start gap-3 py-2" data-testid={`cpa-send-item-${index}`}>
    <Send className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-600" />
    <div className="min-w-0 text-xs">
      <p className="text-stone-800"><span className="font-medium">{send.to_email}</span> <span className="text-stone-500">· {formatSentAt(send.sent_at)}</span></p>
      {send.note && <p className="mt-0.5 truncate italic text-stone-500" title={send.note}>“{send.note}”</p>}
    </div>
  </li>
);

export const CpaShareStrip = ({ sends }) => {
  const [expanded, setExpanded] = useState(false);
  if (!sends.length) return null;
  const latest = sends[0];
  return (
    <div className="mx-4 mt-3 rounded-xl border border-emerald-200 bg-emerald-50/60 px-4 py-2.5" data-testid="cpa-share-strip">
      <button type="button" onClick={() => setExpanded(e => !e)} className="flex w-full items-center justify-between gap-3 text-left" data-testid="cpa-share-strip-toggle">
        <span className="flex min-w-0 items-center gap-2 text-xs text-emerald-900">
          <Send className="h-3.5 w-3.5 shrink-0" />
          <span className="font-semibold">Sent to your CPA</span>
          <span className="truncate text-emerald-800/80" data-testid="cpa-share-strip-latest">
            {sends.length > 1 ? `${sends.length} times · ` : ''}last {formatSentAt(latest.sent_at)} to {latest.to_email}
          </span>
        </span>
        {expanded ? <ChevronUp className="h-4 w-4 text-emerald-700" /> : <ChevronDown className="h-4 w-4 text-emerald-700" />}
      </button>
      {expanded && (
        <ul className="mt-1 divide-y divide-emerald-100" data-testid="cpa-share-strip-list">
          {sends.map((s, i) => <CpaSendItem key={s.sent_at} send={s} index={i} />)}
        </ul>
      )}
    </div>
  );
};

export default CpaShareStrip;
